<div class="filter-top-bar" #filterTopBar>
  <div class="filter-wrapper dropdown">
    <div class="filter-tabs-holder" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)" [cdkDropListConnectedTo]="[deleteArea]">
      <div *ngFor="let filter of filters" cdkDrag (cdkDragStarted)="isBeingDragged = true" (cdkDragEnded)="isBeingDragged = false">
        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
        <div class="filter-tab" *ngIf="filter.show">
          <a cdkDragHandle class="dropdown-toggle d-flex justify-content-center align-items-center" role="button" id="filter-{{ filter.filterKey }}"
            data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside" [ngClass]="{'active': isFilterActive(filter)}">
            <!--<span class="icon-drag-indicator"></span>--> {{ filter.title }}
            <span *ngIf="getPeekForSelectedValues(filter) as peekValue">({{peekValue | truncate: 4}})</span>
          </a>

          <form [formGroup]="form">
            <div *ngIf="filter.filterKey === 'searchById'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" class="form-control pb-5" formControlName="ids" [(ngModel)]="model.ids"
                  placeholder="Search by ID - separate multiple values by space">
                <input-errors [control]="form.controls.ids" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)" [disabled]="form.controls.ids.invalid">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'testGroupIds'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" class="form-control pb-5" formControlName="testGroupIds" [(ngModel)]="model.testGroupIds"
                  placeholder="Search by Test group ID - separate multiple values by space">
                <input-errors [control]="form.controls.testGroupIds" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'destinations'" class="dropdown-menu px-15 py-10 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="filter-{{ filter.filterKey }}">
              <app-destinations-select (onFilterChange)="onFilterChange($event)" (onChange)="onDestinationChange()" [recent]="true"
                [source]="'manual'"></app-destinations-select>
            </div>

            <div *ngIf="filter.filterKey === 'statuses'" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="status-filter-drop">
                <div class="status-filter-list">
                  <div class="d-flex justify-content-end me-10">
                    <span class="cp text-neutral-n7 status-text text-decoration-underline" (click)="onClearAllReceiptStatus()">Clear
                      all</span>
                  </div>
                  <span class="status-title">Statuses</span>
                  <div class="status-list-holder">
                    <div class="status-list" *ngFor="let status of receiptStatuses" (click)="receiptStatusChange($event, status)">
                      <div class="input-check">
                        <input class="form-check-input" type="checkbox" [(ngModel)]="status.selected" [ngModelOptions]="{ standalone: true }" />
                      </div>
                      <span class="icon" [ngClass]="getIconForStatus(status.id)"></span>
                      <span class="status-text">{{ status.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'users'" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="user-filter-drop">
                <app-users-select [multiple]="true" (clear)="onClear($event)" (selectUser)="onSelectUser($event)"
                  (unSelectUser)="onUnSelectUser($event)"></app-users-select>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'date'" class="dropdown-menu px-0 py-15 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="date-filter-drop mx-15">
                <input-search-period type="date" [autoApply]="false" (change)="onChangeDate($event)" [placeholder]="'Date'"></input-search-period>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'searchById'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" class="form-control pb-5" formControlName="ids" [(ngModel)]="model.ids"
                  placeholder="Search by ID - separate multiple values by space">
                <input-errors [control]="form.controls.ids" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)" [disabled]="form.controls.ids.invalid">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'searchByPhoneNumbers'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <textarea class="form-control pb-5" formControlName="phoneNumbers" [(ngModel)]="model.phoneNumbers"
                  placeholder="You can enter multiple phone numbers in new line" rows="5" cols="15"></textarea>
                <input-errors [control]="form.controls.phoneNumbers" [service]="validationService"></input-errors>
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="checkFilterCondition(filter);onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'searchByTestIdText'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="mx-10">
                <input type="text" class="form-control pb-5" formControlName="telqIds" [(ngModel)]="model.telqIds"
                  placeholder="Search by Test ID Text - separate multiple values by space">
              </div>
              <hr>
              <div class="d-flex justify-content-end mx-10">
                <button class="btn mr-10" (click)="onClear(filter.filterKey)">Clear</button>
                <button class="btn btn-primary" (click)="onSubmitClick(filter.filterKey)">Submit</button>
              </div>
            </div>

            <div *ngIf="filter.filterKey === 'channels'" class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1"
              attr.aria-labelledby="fiter-{{ filter.filterKey }}">
              <div class="d-flex justify-content-end me-10">
                <span class="cp text-neutral-n7 status-text text-decoration-underline" (click)="onClearAllChannel()">Clear</span>
              </div>
              <div class="mx-10">
                <div class="d-flex justify-content-start align-items-center gap-0_8 my-10 cp" (click)="onChannelChange('RCS')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="this.model.channels?.includes('RCS')" />
                  </div>
                  <div class="d-flex justify-content-center align-items-center">
                    <span class="icon icon-rcs-positive"></span>
                    <span class="status-text ms-0_5">RCS</span>
                  </div>
                </div>
                <div class="d-flex justify-content-start align-items-center gap-0_8 my-10 cp" (click)="onChannelChange('SMS')">
                  <div class="input-check">
                    <input type="checkbox" class="form-check-input" [checked]="this.model.channels?.includes('SMS')" />
                  </div>
                  <div class="d-flex justify-content-center align-items-center">
                    <span class="icon icon-positive text-success-s2"></span>
                    <span class="status-text  ms-0_5">SMS</span>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="filter-add-btn" *ngIf="shouldAddFilterBeShown()">
      <a role="button" id="add-filter-link" data-bs-toggle="dropdown" aria-expanded="false"><span class="icon-add"></span> Add Filter</a>
      <ul class="dropdown-menu px-0 py-0_8 rounded-15 bg-neutral-n1" attr.aria-labelledby="add-filter-link">
        <ng-container *ngFor="let filter of filters">
          <li *ngIf="!filter.show" class="dropdown-item filter-item px-15 py-10" (click)="onAdditionalFilterClick(filter)">
            <a>{{ filter.title }}</a>
          </li>
        </ng-container>
      </ul>
    </div>

    <div class="v-line"></div>

    <div cdkDropList #deleteArea="cdkDropList" (cdkDropListDropped)="deleteItem($event)">
      <div class="delete-area d-flex justify-content-center align-items-center" (click)="onClearAllFilter()" [ngClass]="{'drag-active': isBeingDragged}">
        <span class="far fa-trash-alt"></span>
        {{isBeingDragged ? 'Remove Filter' : 'Clear Filters'}}
      </div>
    </div>
  </div>

  <div class="filter-right-col">
    <div *ngIf="showUsers" class="d-flex justify-content-center align-items-center gap-10" tooltip="Toggle ON to only show your own tests in Test Results"
      tooltipPlacement="top">
      <span>Show only my tests </span>
      <div class="form-check form-switch" (click)="onChangeOnlyMyTests()">
        <input type="checkbox" class="form-check-input medium" [(ngModel)]="onlyMyTests" [ngModelOptions]="{standalone: true}">
      </div>
    </div>
    <!-- <div class="d-flex justify-content-center align-items-center gap-10 me-20">
            <span>Save search </span>
            <div class="form-check form-switch" (click)="onChangeSaveUserIds()">
                <input type="checkbox" class="form-check-input" [(ngModel)]="saveUserIds" [ngModelOptions]="{ standalone: true }">
            </div>
        </div> -->
    <div class="v-line" style="margin: 0 12px 0 12px;"></div>
    <a class="rounded-icons" role="button" (click)="onClickExport()" [tooltip]="'Export results'">
      <span class="icon-export"></span>
    </a>
  </div>
</div>

<ng-template #usersModalTpl let-dialogRefTemplate="dialogRef">
  <div class="modal-header">
    <button aria-label="Close" class="close" type="button" (click)="dialogRefTemplate.close(true)">
      <span aria-hidden="true">×</span>
    </button>
    <h3 class="modal-title">Users</h3>
  </div>
  <div class="modal-body">
    <app-users-select [multiple]="true" (selectUser)="onSelectUser($event)" (unSelectUser)="onUnSelectUser($event)"></app-users-select>
  </div>
</ng-template>

<ng-template #exportModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Export </h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!exportSpinner" class="spinner export-spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <div *ngIf="!exportData.url">
      <p>Select size:</p>
      <div class="export-option-container" *ngFor="let size of exportSizes" (click)="exportSize = size">
        <input class="form-check-input cp" type="radio" name="exportSize" [value]="size" [(ngModel)]="exportSize" />
        <input *ngIf="size === 'Custom'" class="form-control" type="number" [(ngModel)]="customExportSize" />
        <label *ngIf="size !== 'Custom'" class="form-check-label cp"> {{size}} </label>
      </div>
    </div>
    <div class="pb-20" *ngIf="customExportSize < 1">
      <span class="text-error-r2">Cannot export less than 1 row.</span>
    </div>
    <div *ngIf="exportData.url">
      <br />
      <div class="text-center mb-15">
        <a href="{{ exportData.url }}" target="_blank" class="btn btn-primary">Download</a>
      </div>
    </div>
  </div>
  <div class="modal-footer pt-15" *ngIf="!exportData.url">
    <div class="button-holder d-flex justify-content-between">
      <button [disabled]="exportSpinner" class="btn btn-outline-dark" (click)="dialogRef.close(true)">Cancel</button>
      <button [disabled]="exportSpinner || customExportSize < 1" class="btn btn-primary" (click)="export(exportSize)">
        <span class="icon-export"></span> Export
      </button>
    </div>
  </div>
</ng-template>
